// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "page-policy" + "." + "aa473b60" + ".chunk.css";
};